import { AdBreakFilter, ListResult, SearchableFilter } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'

import { AdBreak } from 'common/api/v1/types'
import { AdBreaksRequestParams, PaginatedRequestParams, singleSortQueryFromPaginatedRequestParams } from '../nm-types'

export interface IAdBreaksApi {
  listAdBreaks(params?: PaginatedRequestParams): Promise<ListResult<AdBreak>>
  getAdBreak(id: AdBreak['id']): Promise<AdBreak>
  deleteAdBreak(id: AdBreak['id']): Promise<AdBreak>
}

export class AdBreaksApi implements IAdBreaksApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  async listAdBreaks(params: AdBreaksRequestParams): Promise<ListResult<AdBreak>> {
    const filter = {
      searchName: params.filter,
      fromDate: params.fromDate ? new Date(params.fromDate) : undefined,
      toDate: params.toDate ? new Date(params.toDate) : undefined,
      status: params.status,
      adId: params.adId,
    } as AdBreakFilter

    const query = singleSortQueryFromPaginatedRequestParams<SearchableFilter, string>({
      filter,
      paginatedRequestParams: params,
    })
    return this.edgeClient.listAdBreaks(query)
  }

  getAdBreak(id: string): Promise<AdBreak> {
    return this.edgeClient.getAdBreak(id)
  }

  deleteAdBreak(id: string): Promise<AdBreak> {
    return this.edgeClient.deleteAdBreak(id)
  }
}
